import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { scrollToTop } from "../../Global/Scroll";
import { errorMessages } from "../../../Constants/Errors";
import { blog_category_page_labels } from "../../../Constants/Labels";
import { alert_message_type } from "../../../Constants/Messages";
import { callAPI, useStore, usePage, useUser } from "../../../Utils/utils";
import Message from "../../Message/Message";
import Alert from "../../Alert/Alert";
import { PopUpMessage } from "../../Global/PopupMessage/PopupMessage";
import ErrorMessage from "../../Global/ErrorMessage";
import "./BlogCategoryEdit.css";

export default function BlogCategoryEdit({ onUpdateCategory }) {
    var { id } = useParams();
    const navigate = useNavigate();
    const { setPage } = usePage();
    const { user } = useUser();
    const { store } = useStore();
    const [errors, setErrors] = useState();
    const [alert, setAlert] = useState();
    const [loading, setLoading] = useState(false);
    const [formValues, setformValues] = useState({});
    const [updatedFormValues, setUpdatedFormValues] = useState();
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [openDelectPopup, setOpenDelectPopup] = useState();

    useEffect(() => {
        setPage({ isLoading: loading });
    }, [loading, setPage]);

    const onChangeField = (event) => {
        const { name, value, type, checked } = event.target;
        const fieldValue = type === "checkbox" ? checked : value;
        setformValues({ ...formValues, [name]: fieldValue });
        setUpdatedFormValues({ ...formValues, [name]: fieldValue });
        setShowErrorMessage(false);
        setErrors([]);
    };

    useEffect(() => {
        if (id && store?.id) {
            callAPI(
                `/admin/blog-categories/${id}`,
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        token: user?.auth_token,
                    }
                },
                navigate,
                setLoading,
            ).then((data) => {
                if (data.success === true) {
                    setformValues(data.record);
                }
            });
        }
    }, [id, store?.id, navigate, user?.auth_token]);

    const saveBlogCategory = () => {
        scrollToTop();
        const payload = {
            blog_category_id: id,
            store_id: store?.id,
            name: updatedFormValues?.name !== undefined ? updatedFormValues?.name?.trim() : formValues?.name,
            status: updatedFormValues?.status !== undefined ? updatedFormValues?.status : formValues?.status,
        };

        callAPI(
            "/admin/blog-categories/update",
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    token: user?.auth_token,
                },
                body: JSON.stringify(payload),
            },
            navigate,
            setLoading,
        ).then((data) => {
            if (data.success === true) {
                onUpdateCategory(alert_message_type.success);
            } else {
                setErrors(data?.errors);
                setShowErrorMessage(true);
                onUpdateCategory(alert_message_type.error);
            }
        });
    };

    const statusOptions = Object.keys(
        blog_category_page_labels?.blog_category_add_and_edit_page_status,
    )?.map((name) => {
        const value = blog_category_page_labels?.blog_category_add_and_edit_page_status[name];
        return `${name},${value}`;
    });

    const onOpenMessagePopUp = () => {
        setOpenDelectPopup(true);
    };

    const onDelete = () => {
        callAPI(
            `/admin/blog-categories/${id}/delete`,
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    token: user?.auth_token,
                },
            },
            navigate,
            setLoading,
        ).then((data) => {
            if (data.success) {
                navigate("/admin/blog-categories");
                localStorage.setItem("Message", "Blog category deleted successfully");
            } else {
                setAlert({ text: "Error deleting category", type: alert_message_type.error });
                setOpenDelectPopup(false);
            }
        });
    };

    const onCloseMessagePopUp = () => {
        setOpenDelectPopup(false);
    };

    return (
        <React.Fragment>
            <button
                className="btn btn-primary saveButton mb-4"
                onClick={saveBlogCategory}
            >
                {blog_category_page_labels?.blog_category_edit_page_labels?.save_btn_label}
            </button>
            <button
                className="btn delectButton mb-4 mx-3"
                onClick={() => onOpenMessagePopUp()}
            >
                {blog_category_page_labels?.blog_category_edit_page_labels?.delete_btn_label}
            </button>
            {openDelectPopup && (
                <PopUpMessage
                    delectMessage={true}
                    isDelect={true}
                    onDelete={onDelete}
                    onClose={onCloseMessagePopUp}
                    recipientsCount={true}
                />
            )}

            {alert?.text && (
                <div className="text-center">
                    <Alert text={alert.text} type={alert.type} setAlert={setAlert} />
                </div>
            )}

            <div className="row">
                <div className="col-lg-8">
                    <div className="card card-default">
                        <div className="card-header card-header-border-bottom">
                            <h2>{blog_category_page_labels?.blog_category_edit_page_labels?.title}</h2>
                        </div>

                        <div className="card-body">
                            <div className="ec-store-uploads">
                                <div className="form-group">
                                    <label className="form-label mandatory_field">
                                        {blog_category_page_labels?.blog_category_add_and_edit_page_labels?.name}
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        maxLength="100"
                                        onChange={onChangeField}
                                        name="name"
                                        value={formValues["name"] || ""}
                                    />
                                    <div className="errorMessage">
                                        <Message
                                            text={errorMessages[ErrorMessage({ fieldName: "name", errors })]}
                                            type={"errorMsg"}
                                            showMessage={showErrorMessage}
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="form-label">
                                        {blog_category_page_labels?.blog_category_add_and_edit_page_labels?.status}
                                    </label>
                                    <select
                                        className="form-control"
                                        name="status"
                                        value={formValues["status"] || ""}
                                        onChange={onChangeField}
                                    >
                                        {statusOptions &&
                                            statusOptions?.map((optionString, index) => {
                                                const [name, value] = optionString.split(",");
                                                return <option value={name} key={index}>{value}</option>;
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
